import React from 'react';
import { useNavigate } from 'react-router-dom';
import { urls } from '..';
import { removeMultipleSlashes } from '../data/sport-utils';
import { getLabel } from '../data/labels';

export default function StreamingAgendaButton() {
    const navigate = useNavigate();

    return (
        <div className="xs_streamingAgendaButton relative h-sports-navbar-height min-w-sports-navbar-height overflow-x-auto mx-1 shrink-0 flex flex-col items-center justify-center" onClick={() => navigate(removeMultipleSlashes(`${urls.base}/${urls.live.base}/agenda`))}>
            <div className="min-w-[60px] grid grid-cols-12 grid-rows-12 max-h-full leading-none items-center justify-items-center">
                <div className={"col-start-1 col-end-13 row-start-1 row-end-10 inline-flex items-center justify-center h-[24px] w-[24px]"}>
                    <img height="24px" width="24px" src={`${process.env.PUBLIC_URL}/assets/images/live-streaming.svg`} alt="Live streaming button" />
                </div>
                <div className="col-start-1 col-end-13 row-start-10 row-end-13 font-bold text-xxs text-cs1 uppercase truncate">{getLabel('live.live_feed')}</div>
            </div>
        </div>
    );
}
